import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import { addNewPlan, getAllPlans } from "../actions/currency";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
// import { useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { AddNewPlan, CURRENT_CHAIN_ID, GetBuyTokenAddress, GetChainIndex, toFixedNumber } from "../Hooks/useWeb3";
import { useSelector } from "react-redux";
import { CHAINS } from "../config/env";
import Form from "react-bootstrap/Form";

const initialFormValue = {
  name: "",
  fee: "",
  validity: "",
  duration: "",
  flashLoanAmount: "",
  highlights: [],
  referralPercentage: "",
  tradesPerDay: "",
  minProfitPercentage: "",
  maxProfitPercentage: "",
  adminCommissionPer: "",
  refferCommissionPer: ""
};

function AddSubscription() {
  const [count, setCount] = useState(1);

  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});
  // const navigate = useNavigate();
  const history = useHistory();
  const [accountInfo, setAccountInfo] = useState("");
  const [planList, setPlanList] = useState();
  const [BUYTOKENADDRESS, setBUYTOKENADDRESS] = useState()
  const [chainId, setChainId] = useState(CURRENT_CHAIN_ID())




  let { adminWalletAddress } = useSelector((state) => state.adminAddress);

  const getPlanList = async () => {
    try {

      let data = {
        chainId: chainId
      }
      let { status, message, result } = await getAllPlans(data);
      if (status == "success") {
        setPlanList(result);
      }
    } catch (err) { }
  };

  const getToken = async () => {
    try {
      let address = await GetBuyTokenAddress();
      setBUYTOKENADDRESS(address)

      let chainId = await CURRENT_CHAIN_ID()
      setChainId(chainId)
    } catch (err) { }
  };


  useEffect(() => {
    getPlanList();
    getToken()
    // setAccountInfo(localStorage.getItem('adminWalletAddress'))
    setAccountInfo(adminWalletAddress)

  }, []);


  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let error = { ...errors };
      error[`${name}`] = "";
      let Formvalue = { ...formvalue, [name]: value };
      setFormvalue(Formvalue);
      setErrors(errors);
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const validation = (value) => {
    try {

      console.log(value, "VALUE")
      let decimal = /^\d+(\.\d+)?$/;
      let error = { ...errors };
      if (isEmpty(value.name)) {
        error["name"] = "Name is required";
      } else {
        error["name"] = "";
      }
      if (isEmpty(value.fee)) {
        error["fee"] = "Fee is required";
      }

      if (!decimal.test(value.fee)) {
        error["fee"] = "Fee must be a valid number";
      } else {
        error["fee"] = "";
      }

      // if (ObjectIsempty(value.validity)) {
      //   error["validity"] = "Validity is required";
      // } else {
      //   error["validity"] = "";
      // }
      if (isEmpty(value.duration)) {
        error["duration"] = "Duration is required";
      } else {
        error["duration"] = "";
      }

      if (isEmpty(value.highlights)) {
        error["highlights"] = "Highlights is required";
      } else {
        error["highlights"] = "";
      }
      if (isEmpty(value.flashLoanAmount)) {
        error["flashLoanAmount"] = "Field is required";
      } else {
        error["flashLoanAmount"] = "";
      }
      if (isEmpty(value.referralPercentage)) {
        error["referralPercentage"] = "Referral Percentage is required";
      } else {
        error["referralPercentage"] = "";
      }
      if (isEmpty(value.tradesPerDay)) {
        error["tradesPerDay"] = "Trades Per Day is required";
      } else {
        error["tradesPerDay"] = "";
      }
      // if (isEmpty(value.minProfitPercentage)) {
      //   error["minProfitPercentage"] = "Min Profit Percentage is required";
      // } else {
      //   error["minProfitPercentage"] = "";
      // }
      if (isEmpty(value.maxProfitPercentage)) {
        error["maxProfitPercentage"] = "Max Profit Percentage is required";
      } else {
        error["maxProfitPercentage"] = "";
      }
      // if (isEmpty(value.adminCommissionPer)) {
      //   error["adminCommissionPer"] = "Admin Profit Commission is required";
      // } else {
      //   error["adminCommissionPer"] = "";
      // }
      if (isEmpty(value.refferCommissionPer)) {
        error["refferCommissionPer"] = "Referral Profit Commission is required";
      } else {
        error["refferCommissionPer"] = "";
      }


      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {

      console.log(formvalue, "FORMVALUE")

      if (adminWalletAddress == "" || adminWalletAddress == null) {
        toast.error("Please Connect Your Wallet!")
      }
      else {
        const index = GetChainIndex();
        console.log("🚀 ~ handleSubmit ~ index:", index)
        let oj = {
          planId: planList.length + 1,
          name: formvalue.name,
          fee: formvalue.fee,
          validity: formvalue.validity,
          duration: formvalue.duration,
          highlights: formvalue.highlights,
          referralPercentage: formvalue.referralPercentage,
          flashLoanAmount: formvalue.flashLoanAmount,
          minProfitPercentage: formvalue.minProfitPercentage,
          maxProfitPercentage: formvalue.maxProfitPercentage,
          adminCommissionPer: formvalue.adminCommissionPer,
          refferCommissionPer: formvalue.refferCommissionPer,
          tradesPerDay: formvalue.tradesPerDay,
          chainId: await CURRENT_CHAIN_ID()
        };
        let isValidate = validation(oj);
        setErrors(isValidate);
        if (!ObjectIsempty(isValidate)) {
          return true;
        }
        let validityMilliseconds = 0

        if (oj.validity != "") {

          if (oj.validity == 'Hours') {
            validityMilliseconds = oj.duration * 60 * 60
          }
          if (oj.validity == 'Days') {
            validityMilliseconds = oj.duration * 24 * 60 * 60

          }
          if (oj.validity == 'Weeks') {
            validityMilliseconds = oj.duration * 7 * 24 * 60 * 60

          }
          if (oj.validity == 'Months') {
            validityMilliseconds = oj.duration * 30 * 24 * 60 * 60
          }
          if (oj.validity == 'Years') {
            validityMilliseconds = oj.duration * 365 * 24 * 60 * 60

          }

        }


        let maxProfit = (formvalue.maxProfitPercentage / 100) * formvalue.fee

        let ContractData = {
          subId: planList.length + 1,
          name: oj.name,
          flashloanLimit: toFixedNumber(oj.flashLoanAmount * 10 ** 6).toString(),
          feeAmount: toFixedNumber(oj?.fee * 10 ** 6).toString(),
          // validity: validityMilliseconds.toString(),
          profitMax: toFixedNumber(maxProfit * 10 ** 6).toString(),
          acceptedToken: CHAINS[index].BUYTOKENADDRESS,
          percent: toFixedNumber(formvalue.referralPercentage * 10 ** 6).toString(),
        }
        let newPlanAdd = await AddNewPlan(ContractData)

        console.log(newPlanAdd, "newPlanAdd")

        if (!isEmpty(newPlanAdd)) {
          let { status, message, result } = await addNewPlan(oj);
          if (status == "success") {
            toast.success("Plan Added Successfully");
            history.push("/subscription");
          } else {
            toast.success("Plan Added Failed");
            history.push("/subscription");
          }
        }

      }



    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };

  const handleHighlights = async (e, index) => {
    try {
      let arr = formvalue.highlights;
      arr[index] = e.target.value;
      let Formvalue = { ...formvalue, ["highlights"]: arr };
      setFormvalue(Formvalue);
      setErrors(validation(Formvalue));
      console.log(Formvalue, index, "EEEEEEE");
    } catch (err) {
      console.log(err, "handleHighlights");
    }
  };

  const options = [
    { value: "Hours", label: "hours" },
    { value: "Days", label: "days" },
    { value: "Weeks", label: "weeks" },
    { value: "Months", label: "months" },
    { value: "Years", label: "years" },
  ];
  const [selectedOption1, setSelectedOption1] = useState("Theme 1");
  const handleChange1 = (e) => {
    console.log(e, "selectedOptionselectedOption");
    let Formvalue = { ...formvalue, ["validity"]: e.value };
    setFormvalue(Formvalue);
    setSelectedOption1(e.value);
  };

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => {
      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00ddeb"
          : isSelected
            ? "#00ddeb"
            : isFocused
              ? "#00ddeb"
              : "#000",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
            ? "#000"
            : isFocused
              ? "#000"
              : "#fff",
        fontSize: "13px",
        zIndex: 1,
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",

      backgroundColor: "transparent",
      color: "red",
      border: "1px solid #2c2c2c",
      borderRadius: "5px",
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "red",
      padding: "0px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#ffffff",
    }),
    menuList: (base) => ({
      ...base,

      padding: 0,
      width: "100%",

      borderRadius: 5,
      background: "transparent",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#fff",
      };
    },
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12} className="pe-3">
            <Header title={"Add Subscription"} />
            <div className="common_page_scroller mt-4 mt-sm-5 pe-2">
              <Row className="profile_holder">
                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Plan name</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="text"
                        placeholder="Plan name"
                        name="name"
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">{errors.name}</span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Price</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Price"
                        name="fee"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">{errors.fee}</span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Trades Per Day</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Trades Per Day"
                        name="tradesPerDay"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.tradesPerDay}
                    </span>
                  </div>
                </Col>



                {/* <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2 d-flex align-items-center gap-2">Min Profit Percentage

                    </p>

                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Min Profit Percentage"
                        name="minProfitPercentage"
                        min={0}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.minProfitPercentage}
                    </span>
                  </div>
                </Col> */}






                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Max Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Max Profit Percentage"
                        name="maxProfitPercentage"
                        min={0}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.maxProfitPercentage}
                    </span>
                  </div>
                </Col>


                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Referral Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Referral Percentage"
                        name="referralPercentage"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.referralPercentage}
                    </span>
                  </div>
                </Col>

                {/* <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Admin Fee Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Admin Profit Commission"
                        name="adminCommissionPer"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.adminCommissionPer}
                    </span>
                  </div>
                </Col> */}

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Referral Fee Profit Percentage</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Referral Profit Commission"
                        name="refferCommissionPer"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">
                      {errors.refferCommissionPer}
                    </span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Flash Loan Limit / Plan</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        placeholder="Flash Loan Limit in $"
                        name="flashLoanAmount"
                        min={1}
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">{errors.flashLoanAmount}</span>
                  </div>
                </Col>

                {/* <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Validity</p>

                    <Select
                      onChange={(e) => handleChange1(e)}
                      options={options}
                      name="validity"
                      defaultValue="theme1"
                      styles={stylesgraybg}
                      isSearchable={false}
                      classNamePrefix="customselect"
                      value={
                        selectedOption1 && selectedOption1?.length > 0
                          ? options?.filter((el) => {
                            if (selectedOption1.includes(el.value)) {
                              return el;
                            }
                          })
                          : []
                      }
                    // defaultInputValue="Theme 1"
                    // menuIsOpen
                    />
                    <span className="text-danger">{errors.validity}</span>
                  </div>
                </Col> */}

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Duration</p>
                    <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                      <input
                        type="number"
                        name="duration"
                        min={1}
                        placeholder="Duration"
                        onChange={handleChange}
                        className="rp_singleInput flex-grow-1"
                      />
                    </div>
                    <span className="text-danger">{errors.duration}</span>
                  </div>
                </Col>

                <Col lg={7} md={8} sm={10} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Highlights</p>
                    {[...Array(count)].map((item, index) => (
                      <div className="mb-3">
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            name="highlights"
                            onChange={(e) => handleHighlights(e, index)}
                            placeholder="Highlights"
                            className="rp_singleInput flex-grow-1"
                          />
                        </div>
                        <div className="d-flex gap-3 justify-content-end mt-3">
                          <button
                            className="subs_add_btn rounded-2"
                            onClick={() => setCount(count + 1)}>
                            <i class="fa-solid fa-plus" />
                          </button>
                          {count != 1 && (
                            <button
                              className="subs_dlt_btn rounded-2"
                              onClick={() => setCount(count - 1)}>
                              <i class="fa-solid fa-trash" />
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>



              </Row>

              <div className="d-flex gap-3 mb-3">
                <button className="secondary_btn">Cancel</button>
                <button
                  className="orange_primary_btn"
                  onClick={() => {
                    handleSubmit();
                  }}>
                  Save
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AddSubscription;
